<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Shifts personnalisés
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Shift (" + error.datas.shiftName + " - " +
                    formatDateRetour(error.datas.startTime) + " " +
                    formatTimeRetour(error.datas.endTime) + ") -> " + error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Export modèle</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export shifts</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="500px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="initdatetime()" block
                         class="custom-btn white--text"
                         color="#009688"
                         height="45px" large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Nouveau shift</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="primary"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier shifts</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="9">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Nom Shift"
                                            prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                            v-model="editedItem.shiftName">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="9">
                              <v-dialog
                                  :return-value.sync="editedItem.startTime"
                                  persistent
                                  ref="dialog2"
                                  v-model="modal2"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Heure début Shift"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted11"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal2"
                                    v-model="editedItem.startTime"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal2 = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog2.save(editedItem.startTime)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="9">
                              <v-dialog
                                  :return-value.sync="editedItem.endTime"
                                  persistent
                                  ref="dialog3"
                                  v-model="modal3"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Heure fin Shift"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted22"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal3"
                                    v-model="editedItem.endTime"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal3 = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog3.save(editedItem.endTime)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="9">
                              <v-select :items="timeMealtypes"
                                        chips
                                        label="Horaire repas"
                                        multiple
                                        persistent-hint
                                        hide-details="true"
                                        item-text="name" item-value="value" return-object solo
                                        prepend-inner-icon="access_time"
                                        v-model="editedItem.timeMeal"
                              >
                                <template #selection="{ item }">
                                                                    <span class="d-flex justify-center"
                                                                          style="width: 50%; font-weight: bold; font-size: 17px;">
                                                                        <v-chip color="white">{{ item }}</v-chip>
                                                                      </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="9">
                              <v-dialog
                                  :return-value.sync="editedItem.dispatchingTime"
                                  persistent
                                  ref="dialog"
                                  v-model="modal4"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Heure Dispatching"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormattedDT"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal4"
                                    v-model="editedItem.dispatchingTime"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal4 = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog.save(editedItem.dispatchingTime)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col md="12" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Observations"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            rows="1"
                                            textarea
                                            v-model="editedItem.observations"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading"
                               @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer shift
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:red;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTableShifts"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Vue from "vue";
import Handsontable from "handsontable";

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 4) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("TimesMeals"));
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "Shifts",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      timeMealtypes: [],
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      modal2: false,
      modal3: false,
      modal4: false,
      toObject: [],
      editedItem: {
        shiftName: "",
        startTime: "",
        endTime: "",
        dispatchingTime: "",
        timeMeal: [],
        observations: ""
      },
      tab: null,
      dialog: false,
      dialog2: false,
      dialog3: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        trimRows: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        comment: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders:
            ["Id", "Nom Shift", "Heure début Shift", "Heure fin Shift", "Horaire repas", "Heure Dispatching", "Observations"],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Nom Shift", width: "100px"},
          {
            title: "Heure début Shift",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Heure fin Shift",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Horaire repas",
            readOnly: true,
            width: "100px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Heure Dispatching",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true
          },
          {title: "Observations", width: "180px"},
        ]
      }
    }
  },

  created() {
    this.getData()
    this.loadTimeMeal()
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.shiftName !== "" &&
          this.editedItem.startTime !== "" &&
          this.editedItem.dispatchingTime !== "" &&
          this.editedItem.endTime !== ""
      );
    },

    computedDateFormatted11() {
      return this.formatTime(this.editedItem.startTime)
    },

    computedDateFormatted22() {
      return this.formatTime(this.editedItem.endTime)
    },

    computedDateFormattedDT() {
      return this.formatTime(this.editedItem.dispatchingTime)
    },
  },

  methods: {
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    initdatetime() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.editedItem.shiftName = "";
      this.editedItem.endTime = "";
      this.editedItem.startTime = "";
      this.editedItem.dispatchingTime = "";
      this.editedItem.timeMeal = [];
      this.editedItem.observations = "";
    },
    formatDateRetour(date) {
      if (!date) return null
      let datetmp = moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      const [year, month, day] = datetmp.split('-')

      return `${day}/${month}/${year}`
    },
    formatTime(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}:${mm}:${ss}`
    },
    formatTimeRetour(time) {
      if (!time) return null

      let timetmp = moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss")
      const [hh, mm, ss] = timetmp.split(':')

      return `${hh}:${mm}:${ss}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shiftspersonalized/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                this.isEmpty(item["shiftName"]) ? "" : item["shiftName"].toUpperCase(),
                item["startTime"],
                item["endTime"],
                this.recomposeTimesMeals(item["timeMeal"]),
                item["dispatchingTime"],
                item["observations"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    recomposeTimesMeals(str) {
      String.prototype.capitalize = function (allWords) {
        return (allWords) ? // if all words
            this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
            this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
      }

      if (this.isEmpty(str))
        return ""
      else if (str.search(",") === -1) {
        return str.trim().toLowerCase().capitalize(true)
      } else {
        let arrayStr = str.split(',')
        arrayStr = arrayStr.sort()

        for (let j = 0; j < arrayStr.length; j++) {
          arrayStr[j] = arrayStr[j].trim().toLowerCase().capitalize(true)
        }

        return arrayStr.join(" et ")
      }
    },
    initEditedItem() {
      this.shiftName = ""
      this.startTime = ""
      this.endTime = ""
      this.dispatchingTime = ""
      this.timeMeal = []
      this.observations = ""
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    loadTimeMeal() {
      this.timeMealtypes = JSON.parse(sessionStorage.getItem("TimesMeals"));
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du Shift.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              console.log('Clicked on proceed');
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let stime = moment(obj[2], "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
              let etime = moment(obj[3], "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
              let dispatchingTime = moment(obj[5], "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

              newObj = {
                "id": obj[0],
                "shiftName": obj[1],
                "startTime": stime,
                "endTime": etime,
                "timeMeal": obj[4],
                "dispatchingTime": dispatchingTime,
                "observations": obj[6],
                "dayChange": (etime <= stime)
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/shift/` +
                      sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    this.dialog = false;
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.refresh()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.text = res.data.message;
                      this.initEditedItem();

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                      this.refresh()
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    this.dialog = false;
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },

    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du Shift.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            console.log('Clicked on proceed');
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/shift/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
          });
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    containsSpace(string) {
      return string.indexOf(' ') !== -1;
    },
    isAlphaNumeric(str) {
      var code, i, len;

      for (i = 0, len = str.length; i < len; i++) {
        code = str.charCodeAt(i);
        if (!(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123)) { // lower alpha (a-z)
          return false;
        }
      }
      return true;
    },
    creer() {
      this.loading = true

      let startTime = moment(this.editedItem.startTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      let endTime = moment(this.editedItem.endTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      let dispatchingTime = moment(this.editedItem.dispatchingTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

      if ((startTime === "Invalid date") || (endTime === "Invalid date") || (dispatchingTime === "Invalid date")) {
        this.text = "Heure saisie invalide. Merci de corriger.";
        this.showAlert('warning')

        this.loading = false
        this.dialog = false;
        return;
      }

      /*if (startTime >= endTime) {
          this.text = "L'heure de début ne peut pas être supérieure à l'heure de fin. Merci de corriger.";
          this.showAlert('warning')

          this.loading = false
          this.dialog = false;
          return;
      }*/

      if (this.containsSpace(this.editedItem.shiftName)) {
        this.text = "La nom du shift ne doit pas contenir d'espace.";
        this.showAlert('warning')

        this.loading = false
        this.dialog = false;
        return;
      }

      /*if (!this.isAlphaNumeric(this.editedItem.shiftName)) {
          this.text = "Le nom du shift ne doit pas contenir de caractères spéciaux.";
          this.showAlert('warning')

          this.loading = false
          this.dialog = false;
          return;
      }*/

      const dataToSave = {
        shiftName: this.editedItem.shiftName,
        startTime: startTime,
        endTime: endTime,
        dayChange: (endTime <= startTime),
        timeMeal: this.editedItem.timeMeal.toString(),
        dispatchingTime: dispatchingTime,
        observations: this.editedItem.observations
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/shift/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.initEditedItem();

              this.showAlert('info')
              this.refresh();
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.showAlert('warning')
              this.refresh();
            }
          })
          .catch(error => {
            this.dialog = false;
            this.alert = true
            this.text = error;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    importFileToHandsonTableShifts() {
      let vm = this;
      vm.loading = true
      this.file = ""
      vm.dialog = false;
      let dataTosave = [];

      const fromExcelDate = require("js-excel-date-convert").fromExcelDate;

      for (let i = 0; i < this.excelData.length; i++) {
        let stime = moment(fromExcelDate(this.excelData[i][1])).format("YYYY-MM-DD HH:mm:ss")
        let etime = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")
        let dispatchingTime = moment(fromExcelDate(this.excelData[i][4])).format("YYYY-MM-DD HH:mm:ss")

        if ((stime === "Invalid date") || (etime === "Invalid date") || (dispatchingTime === "Invalid date")) {
          this.text = "Heure invalide -> Ligne " + (i + 2) +
              ".\nLes heures au format HEURE (cf modèle)."
          this.showAlert('warning')
          this.loading = false
          return;
        }
      }

      for (let i = 0; i < this.excelData.length; i++) {
        let stime = moment(fromExcelDate(this.excelData[i][1])).format("YYYY-MM-DD HH:mm:ss")
        let etime = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")
        let dispatchingTime = moment(fromExcelDate(this.excelData[i][4])).format("YYYY-MM-DD HH:mm:ss")

        dataTosave.push({
          shiftName: this.excelData[i][0],
          startTime: stime,
          endTime: etime,
          timeMeal: this.excelData[i][3],
          dispatchingTime: this.excelData[i][4],
          observations: this.excelData[i][5],
          dayChange: (etime <= stime),
          originUser: sessionStorage.getItem("userId")
        });
      }
      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/shifts/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = [];
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                dataObj.forEach(item => {
                  let tabArray = []
                  tabArray.push([
                    item["id"],
                    this.isEmpty(item["shiftName"]) ? "" : item["shiftName"].toUpperCase(),
                    item["startTime"],
                    item["endTime"],
                    item["timeMeal"],
                    item["dispatchingTime"],
                    item["observations"],
                    this.datefull(item["creationDate"]),
                    item["originUser"]
                  ])
                  vm.hotSettings.data.push(tabArray[0]);
                });
                vm.color = "#009688"
                vm.text = dataObj.length + " Shift(s) ajouté(s).";
                vm.file = "";
                this.showAlert('info')
                this.refresh()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.refresh()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.refresh()
              }
            } else {
              this.alert = true
              this.color = "#F44336"
              this.text = res.data.message;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            vm.loading = false
            vm.alert = true
            vm.text = err;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Shifts") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Shifts.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true;

      // Modele Shifts
      var ws = XLSX.utils.json_to_sheet([
        {
          shiftName: "Nom du shift",
          startTime: "Début Heure Shift",
          endTime: "Fin Heure Shift",
          timeMeal: "Horaire repas",
          dispatchingTime: "Heure Dispatching",
          Observations: "Observations"
        },
        {
          shiftName: "JOUR_08H_20H",
          startTime: "08:00:00",
          endTime: "20:00:00",
          timeMeal: "Déjeuner",
          dispatchingTime: "06:30:00",
          Observations: "Shift de jour pour agents TSA"
        },
        {
          shiftName: "NUIT_20H_08H",
          startTime: "20:00:00",
          endTime: "08:00:00",
          timeMeal: "Diner",
          dispatchingTime: "18:30:00",
          Observations: "Shift de nuit pour agents TSA"
        },
        {
          shiftName: "APREM_13H_16H",
          startTime: "13:00:00",
          endTime: "16:00:00",
          timeMeal: "",
          dispatchingTime: "10:30:00",
          Observations: "Shift TP pour agents ASSA"
        },
        {
          shiftName: "APREM_15H_02H",
          startTime: "15:00:00",
          endTime: "02:00:00",
          timeMeal: "Diner",
          dispatchingTime: "11:30:00",
          Observations: "Shift spécifique pour agent ASSA"
        }
      ], {
        header: ["shiftName", "startTime", "endTime", "timeMeal", "dispatchingTime", "Observations"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Shifts") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Shifts.xlsx", {cellDates: true}) // name of the file is "book.xlsx"

      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}
</style>
 
